import Blue from '~/core';

new Blue({
  name: 'Keyboard Control Outline',
  selector: 'body',
  setup(body) {
    this.$addEvents(body, 'mousedown', () => body.classList.add('using-mouse'));
    this.$addEvents(body, 'keydown', () =>
      body.classList.remove('using-mouse')
    );
  },
});

new Blue({
  name: 'Hide Icons Until Loaded',
  selector: 'body',
  async setup(body) {
    try {
      let ready = document.fonts.ready;
      let load = document.fonts.load('16px ElegantIcons');
      await Promise.all([ready, load]);
    } finally {
      body.classList.add('icons-loaded');
    }
  },
});
